import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { intlShape, injectIntl } from 'react-intl';
import { RelatedStory as PageCard } from '@justgiving/dna-card';
import difference from 'lodash/difference';
import LoadingButton from 'src/components/LoadingButton/';
import defaultAvatar from '../../../static/images/default-avatar.svg';
import { getImageUrlWithTemplate } from '../../helpers/image';
import { isDesktopViewport } from '../../helpers/browser';
import currencyMap from '../../helpers/currencyMap';
import styles from './FeaturedPages.less';

class FeaturedPages extends Component {
  static propTypes = {
    pages: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      pageNo: PropTypes.number.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          projectType: PropTypes.string.isRequired,
          targetCurrency: PropTypes.string.isRequired,
          amountRaised: PropTypes.number.isRequired,
          progress: PropTypes.number.isRequired,
          pitch: PropTypes.string.isRequired,
          owner: PropTypes.string.isRequired,
          numberOfSupporters: PropTypes.number.isRequired,
          projectId: PropTypes.string.isRequired,
          projectUrl: PropTypes.string.isRequired,
          projectImage: PropTypes.shape({
            url: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
            cropArea: PropTypes.shape({
              top: PropTypes.number,
              left: PropTypes.number,
              width: PropTypes.number,
              height: PropTypes.number,
            }),
          }),
        }).isRequired
      ).isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    filter: PropTypes.shape({
      categoryId: PropTypes.number.isRequired,
      typeId: PropTypes.number.isRequired,
      locationId: PropTypes.number.isRequired,
    }),
    loadMore: PropTypes.func.isRequired,
    avatars: PropTypes.objectOf(PropTypes.string),
    loadAvatars: PropTypes.func.isRequired,
    selectCard: PropTypes.func.isRequired,
    intl: intlShape,
  };

  static defaultProps = {
    pageNo: 1,
  };

  static getInitialState() {
    const actualPageSize = isDesktopViewport() ? 6 : 4;

    return {
      actualPageNo: 1,
      actualPageSize,
      pageOffset: actualPageSize,
    };
  }

  constructor(props) {
    super(props);

    this.state = FeaturedPages.getInitialState();
  }

  componentDidMount() {
    const { pages, loadAvatars } = this.props;

    if (__CLIENT__ && pages.items) {
      loadAvatars(pages.items.map(p => p.ownerId));
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      pages: { items },
      filter,
      loadAvatars,
    } = this.props;

    if (__CLIENT__) {
      const owners = items.map(p => p.ownerId);
      const nextOwners = nextProps.pages.items.map(p => p.ownerId);
      const ownersDelta = difference(owners, nextOwners);

      if (ownersDelta.length) {
        loadAvatars(ownersDelta);
      }

      if (filter !== nextProps.filter) {
        this.state = FeaturedPages.getInitialState();
      }
    }
  }

  handleLoadMore = () => {
    const {
      pages: { items, pageNo, totalCount },
      filter: { categoryId, locationId },
      loadMore,
    } = this.props;

    const { actualPageSize, actualPageNo } = this.state;
    const nextPageNo = actualPageNo + 1;
    const nextPageOffset = Math.min(totalCount, actualPageSize * nextPageNo);

    if (items.length < totalCount && items.length < nextPageOffset) {
      loadMore({ pageNo: pageNo + 1, categoryId, locationId });
    }

    this.setState({
      actualPageNo: nextPageNo,
      pageOffset: nextPageOffset,
    });
  };

  renderLoadMoreButton() {
    const {
      pages: { totalCount },
      isLoading,
    } = this.props;
    const { pageOffset } = this.state;

    if (pageOffset < totalCount) {
      return (
        <div styleName="action">
          <LoadingButton
            loading={isLoading}
            onClick={this.handleLoadMore}
            color="purple"
            className={'jg-btn--ghost'}
            value="See more"
          />
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      pages: { items, totalCount },
      avatars,
      selectCard,
      intl,
    } = this.props;
    const { pageOffset } = this.state;

    return (
      <div>
        <div styleName="page-cards">
          {items.slice(0, pageOffset).map((page, i) => {
            const {
              progress,
              pitch,
              owner,
              numberOfSupporters,
              amountRaised,
              ownerId,
              projectImage,
              projectUrl,
              projectId,
              targetCurrency,
              projectType,
            } = page;

            return (
              <div styleName="card" key={projectId}>
                <PageCard
                  percentage={progress || 0}
                  title={pitch}
                  owner={owner}
                  numberOfSupporters={numberOfSupporters}
                  totalRaised={
                    intl.formatNumber(amountRaised, {
                      maximumFractionDigits: 0,
                    }) || 0
                  }
                  ownerAvatar={
                    getImageUrlWithTemplate(
                      avatars[ownerId],
                      'CrowdfundingSupporterAvatar'
                    ) || defaultAvatar
                  }
                  pageImage={getImageUrlWithTemplate(
                    projectImage.url,
                    'Size400w'
                  )}
                  showTotaliser
                  currencySymbol={currencyMap[targetCurrency] || '£'}
                  pageLink={projectUrl}
                  id={projectId}
                  styles={null}
                  onClick={() =>
                    selectCard({
                      id: projectId,
                      type: projectType,
                      url: projectUrl,
                      rank: i + 1,
                      totalCount,
                    })
                  }
                />
              </div>
            );
          })}
        </div>
        {this.renderLoadMoreButton()}
      </div>
    );
  }
}

export default injectIntl(CSSModules(FeaturedPages, styles));



// WEBPACK FOOTER //
// ./src/components/Home/FeaturedPages.js